import * as React from 'react';
import { Slider as MuiSlider, SliderProps } from '@mui/material';
import { useTheme } from 'styled-components';

export const Slider: React.FC<SliderProps> = (props) => {
    const theme = useTheme();

    return (
        <MuiSlider
            {...props}
            className="h-[0.4rem] py-[1.3rem]"
            sx={{
                '& .MuiSlider-thumb': {
                    height: '1.6rem',
                    width: '1.6rem',
                    top: '50% !important',
                    transform: 'translateY(-50%) !important',
                    marginTop: '0 !important',
                    boxShadow: 'none',
                    '&:hover, &.Mui-focusVisible': {
                        boxShadow: `0 0 0 0.8rem ${theme.palette.color.secondary.main}33`,
                    },
                    '&.Mui-active': {
                        boxShadow: `0 0 0 1.2rem ${theme.palette.color.secondary.main}4D`,
                    },
                },
                '& .MuiSlider-track': {
                    height: '0.4rem',
                    borderRadius: '0.2rem',
                    backgroundColor: theme.palette.color.secondary.main,
                },
                '& .MuiSlider-rail': {
                    height: '0.4rem',
                    borderRadius: '0.2rem',
                    opacity: 1,
                    backgroundColor: theme.palette.common.border,
                },
                '& .MuiSlider-valueLabel': {
                    fontFamily: theme.base.fontFace,
                    fontSize: '1.2rem',
                    backgroundColor: 'rgba(0, 0, 0, 0.87)',
                    color: theme.palette.color.white.main,
                },
            }}
        />
    );
};
